export const FLAGS = [
  { flag:"🇦🇷", name:"Argentina" },
  { flag:"🇧🇷", name:"Brazil" },
  { flag:"🇫🇷", name:"France" },
  { flag:"🇩🇪", name:"Germany" },
  { flag:"🇪🇸", name:"Spain" },
  { flag:"🇵🇹", name:"Portugal" },
  { flag:"🏴󠁧󠁢󠁥󠁮󠁧󠁿", name:"England" },
  { flag:"🇮🇹", name:"Italy" },
  { flag:"🇳🇱", name:"Netherlands" },
  { flag:"🇧🇪", name:"Belgium" },
  { flag:"🇭🇷", name:"Croatia" },
  { flag:"🇺🇾", name:"Uruguay" },
  { flag:"🇲🇽", name:"Mexico" },
  { flag:"🇨🇴", name:"Colombia" },
  { flag:"🇨🇭", name:"Switzerland" },
  { flag:"🇩🇰", name:"Denmark" },
  { flag:"🇸🇪", name:"Sweden" },
  { flag:"🇳🇴", name:"Norway" },
  { flag:"🇵🇱", name:"Poland" },
  { flag:"🇷🇸", name:"Serbia" },
  { flag:"🇺🇸", name:"USA" },
  { flag:"🇨🇦", name:"Canada" },
  { flag:"🇦🇺", name:"Australia" },
  { flag:"🇯🇵", name:"Japan" },
  { flag:"🇰🇷", name:"South Korea" },
  { flag:"🇸🇳", name:"Senegal" },
  { flag:"🇲🇦", name:"Morocco" },
  { flag:"🇳🇬", name:"Nigeria" },
  { flag:"🇬🇭", name:"Ghana" },
  { flag:"🇨🇲", name:"Cameroon" },
  { flag:"🇨🇮", name:"Ivory Coast" },
  { flag:"🇪🇬", name:"Egypt" },
  { flag:"🇹🇳", name:"Tunisia" },
  { flag:"🇸🇦", name:"Saudi Arabia" },
  { flag:"🇮🇷", name:"Iran" },
  { flag:"🇯🇴", name:"Jordan" },
  { flag:"🇶🇦", name:"Qatar" },
  { flag:"🇵🇾", name:"Paraguay" },
  { flag:"🇨🇱", name:"Chile" },
  { flag:"🇵🇪", name:"Peru" },
  { flag:"🇪🇨", name:"Ecuador" },
  { flag:"🇧🇴", name:"Bolivia" },
  { flag:"🇺🇦", name:"Ukraine" },
  { flag:"🇹🇷", name:"Turkey" },
  { flag:"🇦🇹", name:"Austria" },
  { flag:"🇭🇺", name:"Hungary" },
  { flag:"🇨🇿", name:"Czech Republic" },
  { flag:"🇬🇷", name:"Greece" },
  { flag:"🏴󠁧󠁢󠁳󠁣󠁴󠁿", name:"Scotland" },
  { flag:"🇮🇸", name:"Iceland" },
];
